export const getTargetGroupUrl = "/api/v3/org/target_group/:tgId";
export const getTargetGroupListUrl = "/api/v3/org/target_group/search";
export const targetGroupAttributesUrl = "/api/v3/defs/tg/attr/list";
export const createTargetGroupUrl = "/api/v3/org/target_group";
export const archiveTargetGroupUrl = "/api/v3/org/target_group/:tgId/archive";
export const restoreTargetGroupUrl = "/api/v3/org/target_group/:tgId/restore";
export const updateTargetGroupUrl = "/api/v3/org/target_group/:tgId";
